class CartDiscountForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="discount-code"]');
    this.button = this.querySelector('button');
    this.message = this.querySelector('[data-discount-message]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    const code = this.input.value.trim();
    if (!code) return;

    this.button.setAttribute('disabled', 'disabled');
    this.message.setAttribute('hidden', 'hidden');
    this.message.textContent = '';

    fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(() => {
        this.input.value = '';
        this.message.textContent = 'Kortingscode toegepast.';
        this.message.removeAttribute('hidden');
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount-form' });
      })
      .catch(() => {
        this.message.textContent = 'Er ging iets mis bij het toepassen van de code.';
        this.message.removeAttribute('hidden');
      })
      .finally(() => {
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('cart-discount-form', CartDiscountForm);
